<div *ngIf="initLoading" class="h-[80vh] w-full flex flex-col items-center justify-center">
  <p-progressSpinner></p-progressSpinner>
</div>

<div>
  <!-- <div class="min-h-screen flex"> -->

  <div class="grid grid-cols-12 gap-x-2 w-full pr-2" *ngIf="!initLoading">


    <div class="col-span-2 px-4 pt-6
  shadow-md bg-white border border-gray-200
  overflow-y-auto rounded-md ml-2 mt-2 h-[90vh] left-col">
      <ul class="space-y-2">
        <li *ngFor="let tab of tabs">
          <button (click)="activeTab = tab.value"
            class="w-full flex items-center justify-between text-sm px-3 py-2 rounded-md transition" [ngClass]="{
                  'bg-blue-600 text-white': activeTab === tab.value,
                  'hover:bg-blue-700 hover:text-white ': activeTab !== tab.value
                }">
            <span class="flex-1 text-left">{{ tab.label }}</span>
            <i class="pi text-base" [ngClass]="{
                    'pi-arrow-circle-right text-gray-300': activeTab !== tab.value,
                    'pi-arrow-circle-down text-white': activeTab === tab.value
                  }">
            </i>
          </button>
        </li>
      </ul>
    </div>


    <div class="col-span-10 h-[90vh] overflow-y-auto px-4 pt-6
  shadow-md bg-white border border-gray-200
  rounded-lg ml-2 mt-2  left-col">
      <ng-container [ngSwitch]="activeTab">

        <div *ngSwitchCase="'details'">
          <app-update-organization [clientId]="clientId">
          </app-update-organization>
        </div>




        <div *ngSwitchCase="'center'">
          <app-center-details [clientId]="clientId"></app-center-details>
        </div>


        <div *ngSwitchCase="'departments'" class="p-4">
          <app-department-details [clientId]="clientId"></app-department-details>
        </div>

        <div *ngSwitchCase="'roles'" class="p-4">
          <app-role-details [clientId]="clientId"></app-role-details>
        </div>

        <div *ngSwitchCase="'users'">
          <app-user-section [clientId]="clientId"></app-user-section>
        </div>

        <div *ngSwitchCase="'emailConfig'" class="p-4">
          <app-email-config [clientId]="clientId"></app-email-config>
        </div>
        <div *ngSwitchCase="'packages'" class="p-4">
          <app-client-package [clientId]="clientId"></app-client-package>
        </div>

        <div *ngSwitchCase="'whatsappConfig'" class="p-4">
          <app-whatsapp-config [clientId]="clientId"></app-whatsapp-config>
        </div>

        <div *ngSwitchCase="'activeDirectoryConfig'" class="p-4">
          <app-active-directory-config-details [clientId]="clientId"></app-active-directory-config-details>
        </div>

        <div *ngSwitchCase="'googleConfig'" class="p-4">
          <app-google-config-details [clientId]="clientId"></app-google-config-details>
        </div>

        <div *ngSwitchCase="'counter'" class="p-4">
          <app-counter [clientId]="clientId"></app-counter>
        </div>

        <!--






      <div *ngSwitchCase="'roles'" class="p-4">
        <app-roles [orgId]="orgId" ></app-roles>
      </div>

      <div *ngSwitchCase="'users'">
        <app-user-section [orgId]="orgId"></app-user-section>
      </div>


      <div *ngSwitchCase="'courses'" class="p-4">
       <app-courses [orgId]="orgId"></app-courses>
      </div>

      <div *ngSwitchCase="'counter'" class="p-4">
        <app-counter [orgId]="orgId"></app-counter>
      </div>

      <div *ngSwitchCase="'packages'" class="p-4">
        <app-orgnization-package [orgId]="orgId"></app-orgnization-package>
      </div>

      <div *ngSwitchCase="'organizationConfig'" class="p-4">
        <app-orgnaization-config [orgId]="orgId"></app-orgnaization-config>
      </div> -->
      </ng-container>
    </div>




  </div>
</div>